import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-english-levels',
    templateUrl: './english-levels.component.html',
    styleUrls: ['./english-levels.component.scss'],
})
export class EnglishLevelsComponent implements OnInit {

    @Input() isCabinetInfo: boolean = false;
    lang = 'uk';

    constructor(
        private modalCtrl: ModalController,
        private translocoService: TranslocoService
    ) {
        this.translocoService.langChanges$.subscribe(language => {
            this.lang = language;
        })
    }

    ngOnInit() {

        console.log(this.isCabinetInfo)
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

}
